@let links = urls();

@if (!isIos) {
  <a [href]="links?.apk" class="app-link" target="_blank">
    <img
      [ngSrc]="baseHref + '/assets/img/navigation/stores/apk.svg'"
      alt="APK version"
      width="110"
      height="44"
    />
  </a>
  @if (isGooglePlayButtonVisible()) {
    <a [href]="links[userLocationA3()] ?? links.global" class="app-link" target="_blank">
      <img
        [ngSrc]="baseHref + '/assets/img/navigation/stores/google-play.svg'"
        alt="Google Play"
        width="110"
        height="44"
      />
    </a>
  }
}
<!--@if (!isAndroid) {-->
<!--  <a [href]="urls[userLocationA3()] ?? urls.global" class="app-link" target="_blank">-->
<!--    <img-->
<!--      ngSrc="/cabinet/assets/img/navigation/stores/appstore.svg"-->
<!--      alt="App Store"-->
<!--      width="101"-->
<!--      height="44"-->
<!--    />-->
<!--  </a>-->
<!--}-->

<!--<div (click)="showQr()" class="app-link app-link&#45;&#45;desktop">-->
<!--  <img-->
<!--    ngSrc="/cabinet/assets/img/navigation/stores/qrcode.svg"-->
<!--    width="44" height="44"-->
<!--    alt="QR Code"-->
<!--  />-->
<!--</div>-->
